export default {
  id: {
    value: null,
    required: false,
    state: null
  },
  data: {
    value: null,
    required: true,
    state: null
  },
  quantidadeParcelas: {
    value: null,
    required: true,
    state: null
  },
  valorTotal: {
    value: null,
    required: true,
    state: null
  },
  taxaJuros: {
    value: null,
    required: true,
    state: null
  },
  valorParcela: {
    value: null,
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/simulacao/modal/simulacaomodal-form.js